function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import classnames from 'classnames';
import T from 'prop-types';
import React, { useMemo } from 'react';
import { PRODUCT_EXPLANATION } from '../../../constants/product';
import text from '../../../text';
import { IconButton } from '../../button';
/* eslint-disable react/prop-types */ var List = function(param) {
    var items = param.items, type = param.type;
    return (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ React.createElement("ul", {
        className: type
    }, items.map(function(item, i) {
        return /*#__PURE__*/ React.createElement("li", {
            className: "",
            key: i
        }, item);
    }));
};
List.propTypes = {
    type: T.string.isRequired,
    items: T.array.isRequired
};
var ProductCardHeader = function(_param) {
    var children = _param.children, isSecondary = _param.isSecondary, onClick = _param.onClick, props = _object_without_properties(_param, [
        "children",
        "isSecondary",
        "onClick"
    ]);
    return !isSecondary ? /*#__PURE__*/ React.createElement("button", _object_spread({
        className: "BadgeCardHeader",
        "aria-disabled": props.isDisabled ? 'true' : undefined,
        onClick: function() {
            return !props.isDisabled && onClick();
        }
    }, props), children) : /*#__PURE__*/ React.createElement("div", {
        className: "BadgeCardHeader"
    }, children);
};
ProductCardHeader.propTypes = {
    children: T.node.isRequired
};
var ProductCardBody = function(param) {
    var pros = param.pros, cons = param.cons, _param_withExplanation = param.withExplanation, withExplanation = _param_withExplanation === void 0 ? false : _param_withExplanation, productType = param.productType, description = param.description;
    var explanation = useMemo(function() {
        if (withExplanation && PRODUCT_EXPLANATION[productType] && !description) {
            return PRODUCT_EXPLANATION[productType];
        }
        return description;
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "BadgeCardBody"
    }, explanation && /*#__PURE__*/ React.createElement("p", {
        className: "explanation"
    }, explanation), /*#__PURE__*/ React.createElement("div", {
        className: "pros-and-cons"
    }, /*#__PURE__*/ React.createElement(List, {
        items: pros,
        type: "pros"
    }), /*#__PURE__*/ React.createElement(List, {
        items: cons,
        type: "cons"
    })));
};
ProductCardBody.propTypes = {
    productType: T.string.isRequired,
    cons: T.array,
    pros: T.array,
    withExplanation: T.bool
};
var ProductCard = function(param) {
    var pros = param.pros, cons = param.cons, productType = param.productType, isDisabled = param.isDisabled, handleClick = param.handleClick, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, _param_withExplanation = param.withExplanation, withExplanation = _param_withExplanation === void 0 ? false : _param_withExplanation, _param_title = param.title, title = _param_title === void 0 ? '' : _param_title, _param_description = param.description, description = _param_description === void 0 ? '' : _param_description;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ProductBadgeCard', {
            secondary: variant === 'secondary',
            tertiary: variant === 'tertiary'
        })
    }, /*#__PURE__*/ React.createElement(ProductCardHeader, {
        onClick: handleClick,
        isDisabled: isDisabled
    }, /*#__PURE__*/ React.createElement("h6", null, title || text("".concat(productType, "3D"))), variant !== 'secondary' && /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled,
        icon: "add"
    })), /*#__PURE__*/ React.createElement(ProductCardBody, {
        pros: pros,
        cons: cons,
        productType: productType,
        withExplanation: withExplanation,
        description: description
    }));
};
ProductCard.propTypes = {
    productType: T.string.isRequired,
    pros: T.array,
    cons: T.array,
    isDisabled: T.bool.isRequired,
    handleClick: T.func.isRequired,
    variant: T.oneOf([
        'default',
        'secondary',
        'tertiary'
    ]),
    withExplanation: T.bool,
    title: T.string,
    description: T.string
};
export default ProductCard;
